import { render } from "./fans.vue?vue&type=template&id=6ee81f00&scoped=true"
const script = {}

import "./fans.vue?vue&type=style&index=0&id=6ee81f00&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ee81f00"

export default script